import { Rewards } from 'components/BitcoinRewardsSection';

export const RewardsPage = () => {
    return <Rewards />;
};
